import { render, staticRenderFns } from "./UserImage.vue?vue&type=template&id=230dbeda&scoped=true&"
import script from "./UserImage.vue?vue&type=script&lang=js&"
export * from "./UserImage.vue?vue&type=script&lang=js&"
import style0 from "./UserImage.vue?vue&type=style&index=0&id=230dbeda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230dbeda",
  null
  
)

export default component.exports